import { router, useLocalSearchParams, useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import AskQuestionForm from '@/components/forms/AskQuestionForm';
import FormWrapper from '@/components/forms/FormWrapper';
import Title from '@/components/Title';
import { i18n } from '@/utils/i18n';

const AskQuestion = () => {
  const navigation = useNavigation();
  const { npoId, name } = useLocalSearchParams<{ npoId: string; name: string }>();

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerShadowVisible: false,
      headerBackVisible: false,
      headerTitle: () => <Title label={name} />,
      headerLeft: () => <GoBackButton />
    });
  }, [name, navigation]);

  return (
    <SafeAreaView style={styles.safe} edges={['bottom']}>
      <FormWrapper scrollEnable={false}>
        <View style={styles.container}>
          <AskQuestionForm
            npoId={npoId}
            messageOnSuccess={i18n.t('question.ask.success_message')}
            onSuccess={() => router.back()}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

export default AskQuestion;

const styles = StyleSheet.create({
  container: {
    paddingTop: 34,
    flex: 1
  },
  safe: {
    flex: 1
  }
});
